import { gql } from "generated-graphql";

export const CREDENTIALS_FOR_STAFF_QUERY = gql(`
  query CredentialsForStaff($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    credentialsForStaff(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
        username
        isEncampOwned
        portalName
        verificationStatus
        lastVerificationCheckAt
        currentlyInUse
        tenantCount
        facilityCount
      }
      count
    }
  }
`);

export const CREDENTIAL_FOR_STAFF_QUERY = gql(`
  query CredentialForStaff($id: ID!) {
    credentialForStaff(id: $id) {
      id
      name
      username
      email
      isEncampOwned
      kind
      portalId
      portalName
      password
      verificationStatus
      lastVerificationCheckAt
      currentlyInUse
      tenantCount
      facilityCount
      tenants {
        id
        name
        facilities {
          id
          name
        }
      }
    }
  }
`);

export const UPSERT_CREDENTIAL_FOR_STAFF = gql(`
  mutation UpsertCredentialForStaff($id: ID, $input: CredentialForStaffInput!) {
    upsertCredentialForStaff(id: $id, input: $input) {
      id
    }
  }
`);

export const LINK_FACILITIES_TO_CREDENTIAL = gql(`
  mutation LinkFacilitiesToCredentialForStaff($credentialId: ID!, $facilityIds: [ID!]!) {
    linkFacilitiesToCredentialForStaff(credentialId: $credentialId, facilityIds: $facilityIds) {
      id
      tenantCount
      facilityCount
      tenants {
        id
        name
        facilities {
          id
          name
        }
      }
    }
  }
`);

export const UNLINK_FACILITIES_FROM_CREDENTIAL = gql(`
  mutation UnlinkFacilitiesFromCredentialForStaff($credentialId: ID!, $facilityIds: [ID!]!) {
    unlinkFacilitiesFromCredentialForStaff(credentialId: $credentialId, facilityIds: $facilityIds) {
      id
      tenantCount
      facilityCount
      tenants {
        id
        name
        facilities {
          id
          name
        }
      }
    }
  }
`);

// Unscoped by tenant on purpose: staff bypass the facility authorization filter,
// so omitting a `tenantId:` term is what makes the picker cross-tenant.
export const STAFF_FACILITY_PICKER_QUERY = gql(`
  query StaffFacilityPicker($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    facilities(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
        customerFacilityId
        streetAddress1
        city
        state
        zip
        tenant {
          id
          name
        }
      }
      count
    }
  }
`);

export const CREDENTIAL_ID_FOR_PORTAL_USERNAME = gql(`
  query CredentialIdForPortalUsername($portalId: ID!, $username: String!) {
    credentialIdForPortalUsername(portalId: $portalId, username: $username)
  }
`);

export const STAFF_PORTAL_OPTIONS = gql(`
  query StaffCredentialPortalOptions($kind: CredentialKind, $includeId: ID, $includeInactive: Boolean) {
    portalPickerOptions(kind: $kind, includeId: $includeId, includeInactive: $includeInactive) {
      id
      jurisdiction
      description
      portalTech
      url
    }
  }
`);
